var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.00068 25C6.00068 25 11.0007 24 12.0007 21C12.0007 21 4.00068 18 6.00068 7C6.00068 7 10.0007 12 16.0007 13V11.0004C16.0008 9.85156 16.3964 8.73783 17.1211 7.84641C17.8457 6.95498 18.8552 6.34023 19.9797 6.10551C21.1043 5.87078 22.2754 6.0304 23.2961 6.55752C24.3168 7.08464 25.125 7.94712 25.5846 8.99996L30.0007 9L26.0007 13C26.0007 20 21.0007 27 12.0007 27C8.00068 27 6.00068 25 6.00068 25Z",
    fill: "#2D3740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00068 25C6.00068 25 11.0007 24 12.0007 21C12.0007 21 4.00068 18 6.00068 7C6.00068 7 10.0007 12 16.0007 13V11.0004C16.0008 9.85156 16.3964 8.73783 17.1211 7.84641C17.8457 6.95498 18.8552 6.34023 19.9797 6.10551C21.1043 5.87078 22.2754 6.0304 23.2961 6.55752C24.3168 7.08464 25.125 7.94712 25.5846 8.99996L30.0007 9L26.0007 13C26.0007 20 21.0007 27 12.0007 27C8.00068 27 6.00068 25 6.00068 25Z",
    stroke: "#2D3740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogoNew);
export default __webpack_public_path__ + "static/media/TwitterLogoNew.a9b4bb79eeb598eb5109553748e43261.svg";
export { ForwardRef as ReactComponent };